import { Map } from 'immutable'
import { handleActions } from 'redux-actions'

import * as actions from './actions'

export default handleActions(
  {
    [actions.startDriftIntelRevealTrialSuccess]: (state) => {
      return state.set('drift_intel_trial_started', true)
    }
  },
  Map()
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/gates/reducer.js